import React from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';
import AnimatedNumbers from 'react-animated-numbers';

const DashboardMetricCard = ({ icon, title, value = 0, subtitle, chips = [], onClick }) => {
  const numericValue = Number(value) || 0;

  return (
    <Box
      onClick={onClick}
      sx={{
        minHeight: 148,
        p: 2,
        borderRadius: 2,
        border: '1px solid #e6ebef',
        bgcolor: '#fff',
        boxShadow: '0 6px 18px rgba(11, 60, 93, 0.08)',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'transform 0.18s ease, box-shadow 0.18s ease',
        '&:hover': onClick
          ? {
              transform: 'translateY(-2px)',
              boxShadow: '0 10px 24px rgba(11, 60, 93, 0.14)',
            }
          : undefined,
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="flex-start">
        <Box
          sx={{
            width: 44,
            height: 44,
            borderRadius: 2,
            bgcolor: '#0B3C5D',
            color: '#D9B310',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          {icon}
        </Box>
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography sx={{ color: '#5f6b76', fontSize: 13, fontWeight: 700 }}>
            {title}
          </Typography>
          <Typography
            component="div"
            sx={{ color: '#0B3C5D', fontWeight: 800, fontSize: 30, lineHeight: 1.2 }}
          >
            <AnimatedNumbers
              animateToNumber={numericValue}
              fontStyle={{ fontSize: 30 }}
              configs={(number, index) => ({
                mass: 1,
                tension: 230 * (index + 1),
                friction: 50,
              })}
            />
          </Typography>
          {subtitle && (
            <Typography sx={{ color: '#697783', fontSize: 12, mt: 0.25 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
      </Stack>

      {chips.length > 0 && (
        <Stack direction="row" spacing={0.75} useFlexGap flexWrap="wrap" sx={{ mt: 1.5 }}>
          {chips.slice(0, 4).map((chip) => (
            <Chip
              key={chip.label}
              size="small"
              label={`${chip.label}: ${chip.count}`}
              variant="outlined"
              sx={{ borderColor: '#d4dde5', color: '#0B3C5D', bgcolor: '#f8fafc' }}
            />
          ))}
        </Stack>
      )}
    </Box>
  );
};

export default DashboardMetricCard;
